// DocQuery.js

import process from "process";
import { apiRequest } from "../Component/Utils/ApiHundler";

const API_BASE_URL = process.env.REACT_APP_API_URL;

/**
 * Met à jour les données pour une instance spécifique.
 * @param {string} token Le token d'authentification
 * @param {string} instanceId L'ID de l'instance à mettre à jour
 * @param {Object} updateData Les données à mettre à jour
 * @returns {Promise<Object>} Le résultat de l'appel d'API
 */
export async function docUpdateADM(token, InstanceId, DocumentId, sComplexite, prio, isValid, ClientId, status) {
  const url = `${API_BASE_URL}/admin/document/update`;

  return await apiRequest(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
    body: JSON.stringify({
      "DocumentId": DocumentId,
      "InstanceId": InstanceId,
      "FieldList": {
        "sComplexite": sComplexite,
        "bValid": isValid,
        "dPriorite": prio,
        "sStatus": status
      },
      "ClientId": ClientId
    }),
  });
}